import "firebase/auth"
import { useAuth } from "reactfire"
import { NavLink as RouterLink } from "react-router-dom"
import {
  useBreakpointValue,
  useTheme,
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Slide,
  Spacer,
} from "@chakra-ui/react"

import Logo from "../Common/AppLogo"

const NavButton = ({ active, children, ...props }) => {
  const theme = useTheme()

  const activeStyle = {
    backgroundColor: theme.colors.sidebar[600],
    color: theme.colors.yellow[300],
  }

  if (!props.onClick) {
    props.activeStyle = activeStyle
  }

  return (
    <Button
      borderRadius="md"
      bg="sidebar.700"
      color="sidebar.200"
      _hover={{ bg: "sidebar.600" }}
      _active={{
        bg: "sidebar.600",
        transform: "scale(0.99)",
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

const Navigation = ({ onClose }) => {
  const auth = useAuth()
  const signOut = () => auth.signOut()

  return (
    <Flex
      as="aside"
      direction="column"
      minH="100vh"
      bg="sidebar.700"
      color="white"
    >
      <Center h="4.5rem" bg="sidebar.900" p={8}>
        <Logo />
      </Center>
      <Grid gap={4} p={4}>
        <NavButton as={RouterLink} to="/admin/ordini">
          Ordini
        </NavButton>
        <NavButton as={RouterLink} to="/admin/inventario">
          Inventario
        </NavButton>
        <NavButton as={RouterLink} to="/admin/comuni">
          Comuni
        </NavButton>
      </Grid>
      <Spacer />
      <Grid gap={4} p={4}>
        <NavButton onClick={signOut}>Esci</NavButton>
      </Grid>
    </Flex>
  )
}

const Sidebar = ({ isOpen, onClose }) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  return isMobile ? (
    <Slide direction="left" in={isOpen} style={{ zIndex: 100 }}>
      <Box w="14rem" bg="teal.500">
        <Navigation onClose={onClose} />
      </Box>
    </Slide>
  ) : (
    <Navigation />
  )
}

export default Sidebar
